export default "__VITE_ASSET__CKadBG1q__"